import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AUTH_PATHS } from './auth-paths-labels';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthClaimsGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly appAuthService: AuthenticationService,
    private readonly router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.canActivateRoute(route, state);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.canActivateRoute(childRoute, state);
  }

  canActivateRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return this.appAuthService.isAuthenticated().then(async (authenticated) => {
      if (authenticated) {
        if (route.data?.authGuardPipe) {
          console.log(`AuthClaimsGuard - Route "${route.url}" is guarded by roles, looking into it...`);
          const roles = await this.appAuthService.roles();
          const guardResult = route.data.authGuardPipe({ roles });
          console.log(`AuthClaimsGuard - Guard validation done`, guardResult);

          if (Array.isArray(guardResult)) {
            return this.router.parseUrl(guardResult.join('/'));
          }
          return guardResult ? true : this.router.parseUrl('/403');
        } else {
          return true;
        }
      }

      console.log(`AuthClaimsGuard - User not authenticated, redirecting to login`);
      return this.router.parseUrl(AUTH_PATHS.SIGN_IN);
    });
  }
}
